import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import { Button, Drawer, Space } from "antd";
import { useCallback, useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AppContext } from "../AppContext";
import GrunGuadLogo from "../assets/logo-white.svg";
import SideBar from "./SideBar/SideBar";
import NotificationPanel from "./NotificationPanel";

export default function NavBar({ userImage }) {
  const { fetchAlarms } = useContext(AppContext);
  const navigate = useNavigate();
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [lang, setLang] = useState(localStorage.getItem("locale") || "en");

  const handleLangToggle = (value) => {
    setLang(value);
    localStorage.setItem("locale", value);
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  useEffect(() => {
    fetchAlarms({ resolved: false });
  }, [fetchAlarms]);

  const onCloseSidebar = useCallback(() => {
    setIsDrawerVisible(false);
  }, []);

  return (
    <>
      <Button
        icon={<MenuOutlined style={{ color: "white" }} />}
        onClick={() => setIsDrawerVisible(true)}
        style={{ marginRight: 10 }}
        type="link"
      />

      <Link to="/">
        <img alt="Grüngard" src={GrunGuadLogo} style={{ height: 32, width: 118 }} />
      </Link>

      <Drawer
        drawerStyle={{ background: "#353739" }}
        bodyStyle={{ padding: 10 }}
        headerStyle={{ backgroundColor: "#353739", borderColor: "#353739", padding: 0 }}
        onClose={() => setIsDrawerVisible(false)}
        closeIcon={null}
        placement="left"
        open={isDrawerVisible}
        width={240}
        title={
          <Space size={0} style={{ height: 50, marginBottom: 10 }}>
            <Button
              icon={<CloseOutlined style={{ color: "white" }} />}
              onClick={() => setIsDrawerVisible(false)}
              style={{ marginRight: 10 }}
              type="link"
            />

            <Link to="/">
              <img alt="Grüngard" src={GrunGuadLogo} />
            </Link>
          </Space>
        }
        zIndex={99999}
      >
        <SideBar onCloseSidebar={onCloseSidebar} />
      </Drawer>

      <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
        <NotificationPanel />

        <Button.Group>
          <Button
            size="small"
            type={lang === "en" ? "primary" : "default"}
            onClick={() => handleLangToggle("en")}
          >
            EN
          </Button>

          <Button
            size="small"
            type={lang === "tr" ? "primary" : "default"}
            onClick={() => handleLangToggle("tr")}
          >
            TR
          </Button>
        </Button.Group>
      </div>
    </>
  );
}
